export function handleError(dispatch, error, type) {
    let errorMessage = '';
    if(error.message) {
        errorMessage = error.message;
    } else if(error.data.message) {
        errorMessage = error.data.message;
    } else if(error.data){
        errorMessage = error.data;
    } else {
    errorMessage = error;
    }
    dispatch({
        type: type,
        payload: errorMessage
    });
}




// WEBPACK FOOTER //
// ./src/actions/ErrorHandler.js